import {
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  Optional,
} from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, debounceTime, take } from 'rxjs';
import { ErrorActions } from 'src/app/error/store/error.slice';
import { SubSink } from 'subsink';

@Directive({
  selector: '[appScrollToInvalidControl]',
  exportAs: 'appScrollToInvalidControl',
})
export class ScrollToInvalidControlDirective implements OnDestroy {
  constructor(
    private el: ElementRef,
    private translate: TranslateService,
    private store: Store,
    @Optional() private formGroupDir: FormGroupDirective
  ) {}

  private subs = new SubSink();

  @HostListener('ngSubmit')
  private onNgSubmit() {
    if (!this.formGroupDir || this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  public scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector('.ng-invalid');

    if (firstInvalidControl) {
      this.el.nativeElement
        .querySelectorAll('.ng-invalid')
        .forEach((node: HTMLElement) => {
          node.classList.replace('ng-untouched', 'ng-touched');
          node.classList.add('mat-form-field-invalid');
        });

      const controlTop = this.getTopOffset(firstInvalidControl);

      if (controlTop < window.scrollY) {
        window.scroll({
          top: controlTop,
          left: 0,
          behavior: 'smooth',
        });
      }

      this.subs.sink = fromEvent(window, 'scroll')
        .pipe(debounceTime(100), take(1))
        .subscribe(() => firstInvalidControl.focus());

      this.displayErrorBanner();
    }
  }

  private displayErrorBanner() {
    this.store.dispatch(
      ErrorActions.handleError({
        traceId: 0,
        message: this.translate.instant(
          'SHARED.SCROLL_TO_INVALID_CONTROL_DIRECTIVE.MESSAGE'
        ),
        errorCode: '',
        globalErrors: {},
        fieldErrors: {},
      })
    );
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return (
      controlEl?.getBoundingClientRect().top + window.scrollY - labelOffset
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
